import { render, staticRenderFns } from "./Zpl.vue?vue&type=template&id=8fb19184&scoped=true"
import script from "./Zpl.vue?vue&type=script&lang=ts"
export * from "./Zpl.vue?vue&type=script&lang=ts"
import style0 from "./Zpl.vue?vue&type=style&index=0&id=8fb19184&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb19184",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fb19184')) {
      api.createRecord('8fb19184', component.options)
    } else {
      api.reload('8fb19184', component.options)
    }
    module.hot.accept("./Zpl.vue?vue&type=template&id=8fb19184&scoped=true", function () {
      api.rerender('8fb19184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/Zpl.vue"
export default component.exports